export type OrderStatus = 'ORDERED' | 'SHIPPED' | 'INVOICED' | 'COMPLAINT';
export const orderStatus = ['ORDERED', 'SHIPPED', 'INVOICED', 'COMPLAINT'];